import { render, staticRenderFns } from "./richtext.vue?vue&type=template&id=14a993d4"
import script from "./richtext.vue?vue&type=script&lang=js"
export * from "./richtext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports